<script setup lang="ts">
import { ContentLoader } from 'vue-content-loader'

// ContentLoader makes random SVG ids otherwise, which differ between SSR and hydration
const uniqueKey = useId()
</script>

<template>
    <ContentLoader
        :height="450"
        primary-color="#C5ECED"
        secondary-color="#E0E0E4"
        :speed="2"
        :unique-key="uniqueKey"
    >
        <rect height="30" rx="5" ry="5" width="152" x="6" y="220.83" />
        <rect height="30" rx="5" ry="5" width="152" x="180" y="220.83" />
        <rect height="30" rx="5" ry="5" width="190" x="6" y="270.83" />
        <rect height="100.96" rx="5" ry="5" width="100%" x="0" y="350.83" />
        <rect height="200" rx="0" ry="0" width="100%" x="0" y="0.83" />
    </ContentLoader>
</template>
